/**
 * 套餐服务模块：获取套餐列表等 API
 */

import { apiService } from './api'
import type {
  PackageListParams,
  PackageListData,
  PackageApiResponse,
} from '@/types/package'

const PACKAGE_ENDPOINT = '/api/packages' as const

/**
 * 获取公开套餐列表
 * @param params 查询参数
 * @returns 套餐列表数据
 */
export async function getPackageList(
  params?: PackageListParams
): Promise<PackageListData> {
  const queryParams: Record<string, string> = {}

  if (params?.current !== undefined) {
    queryParams['current'] = String(params.current)
  }
  if (params?.pageSize !== undefined) {
    queryParams['pageSize'] = String(params.pageSize)
  }

  const response = await apiService.get<PackageApiResponse<PackageListData>>(
    PACKAGE_ENDPOINT,
    queryParams
  )
  return response.data
}
